import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { CFlatList } from '@app/components/Common/';

import { TradeDetailListSection } from './styles';

import TradeDetailListHeader from './TradeDetailListHeader';
import TradeDetailListItem from './TradeDetailListItem';
import TradeDetailError from './TradeDetailError';

import { useFetcher } from '@app/hooks/fetcher';
import { AuthCheckText } from '@app/components';
import { useToken } from '@app/hooks';
import { TradeText } from '@app/organisms/Trade/TradeDetail/TradeFilledTable/styles.tsx';
import { Text } from '@/styles/reactnative.tsx';
import BigNumber from 'bignumber.js';
import { COLORS } from '@app/constants';
import KrwPrice from '@components/KrwPrice.tsx';
import EntryTime from '@components/EntryTime.tsx';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatDecimal4Truncate } from '@utils/formatDecimal.tsx';
import { truncateWithComma } from '@utils/Truncate.ts';
import EmptyMessage from '@/app/components/EmptyMessage';
import useScrollLayout from '../useScrollLayout';

const TradeOrderHistoryTable = ({ parentHeight }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { data: token } = useToken();

  const { t } = useTranslation();

  let KEYURL = '/trade/orderlist?status=*&ep_id=*';

  const { data, isError } = useFetcher(KEYURL, false);

  const list = data?.result?.result?.list;
  const { headerHeight, needsScroll } = useScrollLayout(
    containerRef,
    list,
    parentHeight
  );

  // const dataType = [
  //   "contracts",
  //   "amount",
  //   "orderPrice",
  //   "tradeType",
  //   "orderType",
  //   "margin",
  //   "fee",
  //   "orderTime",
  //   "status",
  // ];

  const columns = [
    {
      width: '11.1%',
      dataIndex: '',
      title: t('contracts'),
      render: (value, data) => (
        <TradeText
          style={{ flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text>
            {data?.pairs}
            <TradeText
              style={{
                color:
                  data?.long_short === 'L'
                    ? COLORS.lightGreen
                    : COLORS.lightRed,
                justifyContent: 'flex-start',
                marginLeft: 5,
              }}
            >
              {data?.long_short === 'L' ? t('long') : t('short')}
            </TradeText>
          </Text>
          <Text
            style={{
              color: 'orange',
              width: 'auto',
              whiteSpace: 'nowrap',
              fontSize: 10,
            }}
          >
            {data?.cross_iso === 'C' ? t('cross') : t('iso')} {data?.leverage}X
          </Text>
        </TradeText>
      ),
    },
    {
      width: '11.1%',
      dataIndex: '',
      title: t('amount'),
      render: (value, data) => {
        return (
          <TradeText style={{ justifyContent: 'flex-start' }}>
            {BigNumber(data?.amount).multipliedBy(data?.leverage).toFormat(3)}
          </TradeText>
        );
      },
    },
    // {
    //   dataIndex: '',
    //   title: t('filledPrice'),
    //   render: (value, data) => {
    //     const currency = data?.pairs?.split("/")[1];
    //     return (
    //       <TradeText style={{whiteSpace: 'nowrap', justifyContent: 'flex-start'}}>
    //         {data?.trade_price || data?.order_price} {currency}
    //       </TradeText>
    //     );
    //   },
    // },
    {
      width: '11.1%',
      dataIndex: '',
      title: t('orderPrice'),
      render: (value, data) => {
        const currency = data?.pairs?.split('/')[1];
        return (
          <TradeText
            style={{ whiteSpace: 'nowrap', justifyContent: 'flex-start' }}
          >
            {data?.limit_market !== 'M'
              ? `${data?.order_price} ${currency}`
              : '-'}
          </TradeText>
        );
      },
    },
    {
      width: '11.1%',
      dataIndex: '',
      title: t('conclusionPrice'),
      render: (value, data) => {
        const currency = data?.pairs?.split('/')[1];
        console.log(data);
        return (
          <TradeText
            style={{ whiteSpace: 'nowrap', justifyContent: 'flex-start' }}
          >
            {(data?.status === 1 || data?.status === 2) && data?.trade_price
              ? `${data?.trade_price} ${currency}`
              : '-'}
          </TradeText>
        );
      },
    },
    {
      width: '11.1%',
      dataIndex: '',
      title: t('orderType'),
      render: (value, data) => {
        return (
          <TradeText
            style={{ whiteSpace: 'nowrap', justifyContent: 'flex-start' }}
          >
            {data?.limit_market === 'L' ? t('limit') : t('market')}{' '}
            {data?.data?.is_triggered && ` (${t('trigger')})`}
          </TradeText>
        );
      },
    },
    {
      width: '11.1%',
      dataIndex: '',
      title: t('margin'),
      render: (value, data) => {
        const currency = data?.pairs?.split('/')[1];
        return (
          <TradeText
            style={{ whiteSpace: 'nowrap', justifyContent: 'flex-start' }}
          >
            {truncateWithComma(data?.margin, 3)} {currency}
          </TradeText>
        );
      },
    },
    {
      width: '11.1%',
      dataIndex: '',
      title: t('fee'),
      render: (value, data) => {
        return (
          <KrwPrice
            dp={3}
            price={formatDecimal4Truncate(
              -BigNumber(data?.fee_price).toNumber()
            )}
            krw={true}
          />
        );
      },
    },
    {
      width: '11.1%',
      dataIndex: '',
      title: t('orderTime'),
      render: (value, data) => {
        return (
          <EntryTime
            style={{ justifyContent: 'left' }}
            time={data?.created_at}
          />
        );
      },
    },
    {
      width: '11.1%',
      dataIndex: '',
      title: t('status'),
      render: (value, data) => {
        return (
          <div style={{}}>
            {data?.status === 1
              ? t('opened')
              : data?.status === 2
                ? t('filled')
                : t('canceled')}
          </div>
        );
      },
    },
  ];

  // const renderItem = (item: any, index: any) => {
  //   return (
  //     <TradeDetailListItem
  //       item={item}
  //       index={index}
  //       dataType={dataType.length}
  //     />
  //   );
  // };

  return (
    <TradeDetailListSection ref={containerRef}>
      {/*<TradeDetailListHeader dataType={dataType} />*/}
      {isError ? <TradeDetailError /> : null}

      {token ? null : <AuthCheckText />}

      {list?.length ? (
        <Table
          columns={columns}
          dataSource={list}
          pagination={false}
          style={{ width: '100%', height: '100%' }}
          sticky={true}
          size="small"
          scroll={
            needsScroll
              ? {
                  x: 'max-content',
                  y: parentHeight - (headerHeight || 38) - 20, // 실제 헤더 높이 + 여백
                }
              : {
                  x: 'max-content',
                }
          }
        />
      ) : (
        <EmptyMessage />
      )}
      {/*{list?.length ? <CFlatList data={list} renderItem={renderItem} /> : null}*/}
    </TradeDetailListSection>
  );
};

export default TradeOrderHistoryTable;
